import { fetchConToken } from "../helpers/fetch";
import { armarParametrosLiquidaciones } from "../helpers/parametros";

export const LiquidacionesService = {
  getComprobantesGestion: (
    idEfectorFacturacion,
    fechaDesde,
    fechaHasta,
    idEstadoSolicitud,
    idComprobante
  ) => {
    return fetchConToken(
      `MesaEntrada/traerComprobantesLiquidacion?
        ${armarParametrosLiquidaciones(
        idEfectorFacturacion,
        fechaDesde,
        fechaHasta,
        idEstadoSolicitud,
        idComprobante
      )
      }`
    );
  },
  getContadoresLiquidacionesGestion: (
    idEfectorFacturacion,
    fechaDesde,
    fechaHasta,
    idEstadoSolicitud,
    idComprobante
  ) => {
    return fetchConToken(
      `MesaEntrada/traerContadoresComprobantesLiquidacion?
        ${armarParametrosLiquidaciones(
        idEfectorFacturacion,
        fechaDesde,
        fechaHasta,
        idEstadoSolicitud,
        idComprobante
      )
      }`
    );
  },
  //COMPROBANTE
  putEstadoComprobante: (idComprobante, idEstadoComprobante) => {
    return fetchConToken(`mesaEntrada/editarEstadoExpedienteLiquidaciones`, { idComprobante, idEstadoComprobante }, "PUT");
  },
  putDevolucionExpMesaEntrada: (idComprobante, idEstadoComprobante) => {
    return fetchConToken(`mesaEntrada/devolucionExpendienteAMesaEntrada`, { idComprobante, idEstadoComprobante }, "PUT");
  },
  putEstadoComprobantes: (idsComprobantes, idEstadoComprobante) => {
    return fetchConToken(`mesaEntrada/editarEstadoExpedientesLiquidaciones`, { idsComprobantes, idEstadoComprobante }, "PUT");
  },
  putGenerarVoucherLiquidaciones: (idsComprobantes, idEstadoComprobante) => {
    return fetchConToken(`mesaEntrada/generarSolicitudDePago`, { idsComprobantes, idEstadoComprobante }, "PUT");
  },
  putAnularVoucherLiquidaciones: (idSolicitudPago) => {
    return fetchConToken(`mesaEntrada/anularSolicitudDePago`, { idSolicitudPago }, "PUT");
  },
  putEmailEfectorComprobante: (idComprobante, emailEfector) => {
    return fetchConToken(`mesaEntrada/editarEmailEfector`, { idComprobante, emailEfector }, "PUT");
  },
  //TOTAL LINEAS COMPROBANTE
  getTotalDebitosLineasComprobante: (idComprobante) => {
    return fetchConToken(`lineaComprobante/traerMontoTotalDebitosLineas/${idComprobante}`);
  },
  getTotalLineasComprobante: (idComprobante) => {
    return fetchConToken(`lineaComprobante/traerMontoTotalLineas/${idComprobante}`);
  },
  insertLineasPorIdSolicitud: (data) => {
    console.log(data);
    return fetchConToken(`lineaComprobante/insertLineasPorIdSolicitud`, data, "POST");
  },
  deleteTodasLineasComprobante: (idComprobante) => {
    return fetchConToken(`lineaComprobante/deleteTodasLineasComprobante`, { idComprobante }, "DELETE");
  },
  //LINEAS PRESTACION
  getLineasPrestacion: (idComprobante) => {
    return fetchConToken(`lineaComprobante/traerLineasPrestacion/${idComprobante}`);
  },
  insertLineaPrestacion: (data) => {
    return fetchConToken(`lineaComprobante/insertLineaPrestacion`, data, "POST");
  },
  modificarLineaPrestacion: (data) => {
    return fetchConToken(`lineaComprobante/modificarLineaPrestacion`, data, "PUT");
  },
  updateLineaPrestacionSinCalculoCoseguro: (data) => {
    return fetchConToken(`lineaComprobante/updateLineaPrestacionSinCalculoCoseguro`, data, "PUT");
  },
  deleteLineaPrestacion: (data) => {
    return fetchConToken(`lineaComprobante/deleteLineaPrestacion`, data, "DELETE");
  },
  deleteLineaPrestacionMasiva: (data) => {
    return fetchConToken(`lineaComprobante/deleteLineaPrestacionMasiva`, data, "DELETE");
  },
  updateLineaPrestacion: (data) => {
    return fetchConToken(`lineaComprobante/updateLineaPrestacion`, data, "PUT");
  },
  //LINEAS INSUMO
  getLineasInsumos: (idComprobante) => {
    return fetchConToken(`lineaComprobante/traerLineasInsumos/${idComprobante}`);
  },
  insertLineaInsumo: (data) => {
    return fetchConToken(`lineaComprobante/insertLineaInsumo`, data, "POST");
  },
  modificarLineaInsumo: (data) => {
    return fetchConToken(`lineaComprobante/modificarLineaInsumo`, data, "PUT");
  },
  deleteLineaInsumo: (data) => {
    return fetchConToken(`lineaComprobante/deleteLineaInsumo`, data, "DELETE");
  },
  deleteLineaInsumoMasiva: (data) => {
    return fetchConToken(`lineaComprobante/deleteLineaInsumoMasiva`, data, "DELETE");
  },
  updateLineaInsumo: (data) => {
    return fetchConToken(`lineaComprobante/updateLineaInsumo`, data, "PUT");
  },
  updateArchivosScienza: (data) => {
    return fetchConToken(`FileUpload/ConfirmacionArchivosScienzaLiquidaciones`, data, "POST");
  },
  //LINEAS MEDICAMENTO
  getLineasMedicamento: (idComprobante) => {
    return fetchConToken(`lineaComprobante/traerLineasMedicamento/${idComprobante}`);
  },
  //COMPROBANTES TOMADOS
  getComprobantesTomadosPorUsuario: () => {
    return fetchConToken(`comprobantesTomados/traerPorUsuario`);
  },
  getComprobantesTomados: () => {
    return fetchConToken(`comprobantesTomados/traerTomados`);
  },
  putLiberarComprobante: (id) => {
    return fetchConToken(`comprobantesTomados`, { id }, "PUT");
  },
  postTomarComprobante: (idComprobante) => {
    return fetchConToken(`comprobantesTomados`, { idComprobante }, "POST");
  },
  //TRACKING LINEA COMPROBANTE
  getTrackingLineaPrestacion: (idComprobante, idItemPractica) => {
    return fetchConToken(`trackingLineaComprobante/traerLineaPrestacion/${idComprobante}/${idItemPractica}`);
  },
  getTrackingLineaInsumo: (idComprobante, idItemInsumo) => {
    return fetchConToken(`trackingLineaComprobante/traerLineaInsumo/${idComprobante}/${idItemInsumo}`);
  },
  enviarPDFSolicitud: (idSolicitudPago, esDebitos, esPrestador) => {
    return fetchConToken(`lineaComprobante/enviarPDF/${idSolicitudPago}/${esDebitos}/${esPrestador}`);
  },
  previsualizarSolicitudPago: (idComprobante, esDebitos) => {
    return fetchConToken(`MesaEntrada/previsualizarSolicitudPago/${idComprobante}/${esDebitos}`, {
      responseType: 'blob'
    });
  },
  imprimirSolicitudPago: (esDebitos, idSolicitudPago) => {
    return fetchConToken(`MesaEntrada/SolicitudPagoLiqui/${esDebitos}/${idSolicitudPago}`, {
      responseType: 'blob'
    });
  },

  insertLineaMedicamento: (data) => {
    return fetchConToken(`lineaComprobante/insertLineaMedicamento`, data, "POST");
  },
  getValorMedicamento: (nroReg, fechaDispensa) => {
    return fetchConToken(`RecetasDigitales/BusquedaMedicamentosValorFecha?nroReg=${nroReg}&fechaDispensa=${fechaDispensa}`)
  },
  updateLineaMedicamento: (data) => {
    return fetchConToken(`lineaComprobante/updateLineaMedicamento`, data, "PUT");
  },
  deleteLineaMedicamento: (data) => {
    return fetchConToken(`lineaComprobante/deleteLineaMedicamento`, data, "PUT");
  },
  deleteLineaMedicamentoMasiva: (data) => {
    return fetchConToken(`lineaComprobante/deleteLineaMedicamentoMasiva`, data, "DELETE");
  },
  debitoCompletoLineasPrestaciones: (data) => {
    return fetchConToken(`lineaComprobante/debitoCompletoLineasPrestacions`, data, "PUT");
  },
  getMotivosDebito: () => {
    return fetchConToken(`motivosDebito`);
  },
  //Documentacion
  TraerTipoDocumentacion: () => {
    return fetchConToken(`LiquidacionesDocumentacion/TraerTipoDocuLiqui`);
  },
  TraerDocumentacionPorIdExp: (idTipoDocu) => {
    return fetchConToken(`LiquidacionesDocumentacion/${idTipoDocu}`);
  },
  DeleteDocumentacion: (idLiquidacionesDocumentacion) => {
    return fetchConToken(`LiquidacionesDocumentacion/${idLiquidacionesDocumentacion}`, {}, "DELETE");
  },
  getExcelLiquidaciones: (idExpediente, idTipoConsulta) => {
    return fetchConToken(
      `lineaComprobante/GenerarExcelLineasPrestacion/${idExpediente}/${idTipoConsulta}`,
    );
  },
}